import React from 'react'
import { Box, Text } from '@mantine/core'

interface TargetPointsProps {
  points: string
}

export const TargetPoints: React.FC<TargetPointsProps> = ({ points }) => (
  <Box
    style={{
      background: 'linear-gradient(135deg, #FFFFFD 0%, #FEF6D4 100%)',
      borderRadius: 12,
      display: 'inline-block',
      padding: '8px 20px',
      marginBottom: 16,
      boxShadow: '0 4px 12px rgba(161, 58, 26, 0.15)',
      border: '1px solid rgba(161, 58, 26, 0.1)',
    }}
  >
    <Text
      style={{
        color: '#A13A1A',
        fontWeight: 700,
        fontSize: 16,
        lineHeight: '22px',
      }}
    >
      🎯 累计{points}积分即可参与抽奖
    </Text>
  </Box>
)

interface CurrentPointsProps {
  points: number
}

export const CurrentPoints: React.FC<CurrentPointsProps> = ({ points }) => (
  <Box style={{ marginBottom: 20 }}>
    <Text style={{ color: '#613A22', fontSize: 18, fontWeight: 500, display: 'inline' }}>当前累计</Text>
    <Text
      style={{
        color: '#FF5A5A',
        fontSize: 20,
        fontWeight: 700,
        display: 'inline',
        margin: '0 6px',
        textShadow: '0 2px 4px rgba(255, 90, 90, 0.3)',
      }}
    >
      {points.toLocaleString()}积分
    </Text>
    <span style={{ fontSize: 16 }}>💎</span>
  </Box>
)
